export default __webpack_public_path__ + "static/media/05.e09b7e36.jpg";